type Props = {
  title?: string;
  processCode?: string;
};
export const FlowModalTitle: React.FC<Props> = ({ title, processCode }) => {
  if (!title) return <div></div>;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <span>{title}</span>
      {processCode && (
        <>
          <div
            style={{
              width: "2px",
              height: "20px",
              backgroundColor: "#d9d9d9",
              display: "inline-block",
              flexShrink: 0,
            }}
          />
          <span style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.45)" }}>
            单号：{processCode}
          </span>
        </>
      )}
    </div>
  );
};
